import { ca } from '@cian/analytics';

export const trackButtonClick = () => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Card_CSP',
    action: 'Click',
    label: 'reliable_company',
    useLastProducts: true,
  });
};
